import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'
import Shimmer from 'react-shimmer-effect'

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear + 3 ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

class IndexView extends Component {

    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            rankOption: [],
            ikuOption: [],
            detail:{},
            emptype:'',
            detailSKP:{},
            satuanWaktuOption: [
                { label: "Bulan", value: 'Bulan' },
                { label: "Triwulan", value: 'Triwulan' },
                { label: "Semester", value: 'Semester' }
            ]
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }
    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }
    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, '') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchInputRealisasi(formData)
        console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    componentDidMount() {

        this.createBloc.inputRealisasiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:

                    if (result.data.status){
                        this.setState({
                            loading: false,
                            success: true
                        });
                    } else {
                        this.setState({
                            loading: false,
                            message: result.data.message,
                            failed: true
                        });
                    }

                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.detailSKPChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detailSKP: response,
                        })
                        console.log(response)
                        this.createBloc.fetchEmployee({uuid: this.state.detailSKP?.skp_period_employee_uuid })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        this.setState({
                            detail: response_employee,
                            emptype : response_employee?.employee_type_name.toLowerCase()
                        })
                        // console.log(this.state.emptype.toLowerCase())
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        // this.createBloc.fetchRank()
        // this.createBloc.fetchEchelon()
        this.createBloc.fetchSKP({uuid: this.queryParams.get('uuid')})
        // this.createBloc.fetchInitialHeader({employee_uuid: this.queryParams.get('euuid') })
        // this.createBloc.fetchEmployee({uuid: this.queryParams.get('euuid') })
        
    }

    componentWillUnmount(){
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.initialHeaderChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Input  Realisasi SKP</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                        {/* <div>
                                            <label>Data Pegawai</label><br />
                                            <Row className="mb-3">
                                                <label className="col-md-2">
                                                NIP
                                                </label>
                                                <Col md="8">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-2">
                                                Nama
                                                </label>
                                                <Col md="8">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-2">
                                                Tempat, Tanggal Lahir
                                                </label>
                                                <Col md="8">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.getEmployeeBirthDetail(this.state.detail)}</>
                                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-2">
                                                Jabatan
                                                </label>
                                                <Col md="8">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                        : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-2">
                                                Unit Kerja
                                                </label>
                                                <Col md="8">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                        : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                        </div> */}
                                    {/* <hr /><br /> */}
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                    {(this.state.detailSKP?.skp_period_type==2)?
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Index Kinerja Utama <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="skp_iku_activity"
                                                    type="textarea"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_iku_activity"
                                                    value={this.state.detailSKP?.skp_iku_name}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        :''
                                    }
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Kegiatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="skp_activity"
                                                    placeholder="Kegiatan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Target Angka Kredit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_activity"
                                                    value={this.state.detailSKP?.skp_activity}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <hr />
                                    <Row className="mb-12">
                                    
                                    <Col md="6">  
                                        
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            <i className="uil-focus-target"></i> Target
                                            </label>
                                        </Row>
                                        <hr />
                                        {(this.state.emptype=='fungsional tertentu')?
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Angka Kredit <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_angka_kredit"
                                                    // placeholder="Target Angka Kredit..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Angka Kredit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_angka_kredit"
                                                    value={this.state.detailSKP.skp_target_angka_kredit}
                                                    readonly="readonly"
                                                />
                                                <AvField
                                                    name="skp_created_by"
                                                    // placeholder="Target Angka Kredit..."
                                                    type="hidden"
                                                    id="skp_created_by"
                                                    value={this.state.detailSKP.skp_created_by}
                                                />
                                                <AvField
                                                    name="skp_period_uuid"
                                                    // placeholder="Target Angka Kredit..."
                                                    type="hidden"
                                                    id="skp_period_uuid"
                                                    value={this.state.detailSKP.skp_period_uuid}
                                                />
                                            </Col>
                                        </Row> : ''}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Ku Target Kuantitas Output <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_kuantitas"
                                                    // placeholder="Target Kuantitas..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Kuantitas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_kuantitas"
                                                    value={this.state.detailSKP?.skp_target_kuantitas}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Satuan Kuantitas Output<span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_output"
                                                    // placeholder="Target Output..."
                                                    type="text"
                                                    errorMessage="Masukkan Target Output"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_output"
                                                    value={this.state.detailSKP?.skp_target_output}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Kualitas Mutu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_kualitas_mutu"
                                                    // placeholder="Target Kualitas Mutu..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Kualitas Mutu"
                                                    className="form-control"
                                                    id="skp_target_kualitas_mutu"
                                                    value={this.state.detailSKP?.skp_target_kualitas_mutu}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_waktu"
                                                    // placeholder="Target Waktu..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_waktu"
                                                    value={this.state.detailSKP?.skp_target_waktu}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Satuan Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_satuan_waktu"
                                                    placeholder="Target Satuan Waktu..."
                                                    type="nutextmber"
                                                    errorMessage="Masukkan Target Satuan Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_target_satuan_waktu"
                                                    value={this.state.detailSKP?.skp_target_satuan_waktu}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Target Biaya{/*  <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_target_biaya"
                                                    // placeholder="Target Biaya..."
                                                    type="number"
                                                    errorMessage="Masukkan Target Biaya"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="skp_target_biaya"
                                                    value={this.state.detailSKP?.skp_target_biaya}
                                                    readonly="readonly"
                                                />
                                            </Col>
                                        </Row>          

                                        
                                    </Col>
                                    <Col md="6">
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            <i className="uil-check-square"></i> Realisasi
                                            </label>
                                        </Row>
                                        <hr />
                                        <AvField
                                                name="skp_uuid"
                                                type="hidden"
                                                id="skp_uuid"
                                                value={this.state.detailSKP?.skp_uuid}
                                            />
                                    {(this.state.emptype=='fungsional tertentu')?
                                        <>
                                        <Row className="mb-12">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Angka Kredit <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_angka_kredit"
                                                    // placeholder="Realisasi Angka Kredit..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Angka Kredit"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_angka_kredit"
                                                    value={this.state.detailSKP?.skp_realisasi_angka_kredit}
                                                />
                                            </Col>
                                        </Row><br /></>:''}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Target Kuantitas Output <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_kuantitas"
                                                    // placeholder="Realisasi Kuantitas..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Kuantitas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_kuantitas"
                                                    value={this.state.detailSKP?.skp_realisasi_kuantitas}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Satuan Kuantitas Output<span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_output"
                                                    // placeholder="Realisasi Output..."
                                                    type="text"
                                                    errorMessage="Masukkan Realisasi Output"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_output"
                                                    value={this.state.detailSKP?.skp_realisasi_output}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Kualitas Mutu (%) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_kualitas_mutu"
                                                    // placeholder="Realisasi Kualitas Mutu..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Kualitas Mutu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_kualitas_mutu"
                                                    value={this.state.detailSKP?.skp_realisasi_kualitas_mutu}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_waktu"
                                                    // placeholder="Realisasi Waktu..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_waktu"
                                                    value={this.state.detailSKP?.skp_realisasi_waktu}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Satuan Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="skp_realisasi_satuan_waktu"
                                                    errorMessage="Pilih Realisasi Satuan Waktu"
                                                    options={this.state.satuanWaktuOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Realisasi Satuan Waktu"
                                                    defaultValue={this.state.detailSKP?.skp_realisasi_satuan_waktu}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Realisasi Biaya{/*  <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_biaya"
                                                    // placeholder="Realisasi Biaya..."
                                                    type="number"
                                                    errorMessage="Masukkan Realisasi Biaya"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="skp_realisasi_biaya"
                                                    value={this.state.detailSKP?.skp_realisasi_biaya}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-4 col-form-label"
                                            >
                                            Tanggal Realisasi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="skp_realisasi_tanggal"
                                                    // placeholder="Realisasi Biaya..."
                                                    type="date"
                                                    errorMessage="Masukkan Realisasi Tanggal"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_realisasi_tanggal"
                                                    value={this.state.detailSKP?.skp_realisasi_tanggal}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    
                                        <hr />
                                    </Row> 
                                        <Row>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/skp.html?datakegiatan&euuid=${this.state.detail.employee_uuid}&perioduuid=${this.state.detailSKP?.skp_period_uuid}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.message ?? "Data gagal disimpan"}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/skp.html?datarealisasi&euuid=${this.state.detailSKP.skp_period_employee_uuid}&perioduuid=${this.state.detailSKP.skp_period_uuid}`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView